'use client';

import { useState } from 'react';
import { Button } from '@/src/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/src/components/ui/tooltip';
import { useCopyToClipboard } from '@/src/lib/hooks/useCopyClipboard';
import { useTranslations } from 'next-intl';
import CopyIcon from '@/src/components/icons/CopyIcon';
import CopiedIcon from '@/src/components/icons/CopiedIcon';

interface CopyCouponCodeProps {
  code: string;
}

export const CopyCouponCode = ({ code }: CopyCouponCodeProps) => {
  const { handleCopy } = useCopyToClipboard();
  const [open, setOpen] = useState(false);
  const t = useTranslations('stores');

  const onCopy = async () => {
    await handleCopy(code);

    setOpen(true);

    setTimeout(() => {
      setOpen(false);
    }, 2000);
  };

  return (
    <Tooltip open={open}>
      <TooltipTrigger asChild>
        <Button
          onClick={onCopy}
          variant="secondary"
          className="h-9! w-fit! gap-2 bg-white text-base"
        >
          {open ? <CopiedIcon className="scale-150" /> : <CopyIcon className="scale-150" />}
          <span>{code}</span>
        </Button>
      </TooltipTrigger>

      <TooltipContent side="top" className="border-0 bg-[#1E1E1E]">
        {t('codeCopy')}
      </TooltipContent>
    </Tooltip>
  );
};

export const CopyCopounCode = CopyCouponCode;
